import { Route, Routes } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import Header from "./components/Header";
import SideNavbar from "./components/Sidebar";
import ContactQRCode from "./components/QRCode/ContactQRCode";
import WordToPdfConverter from "./components/FileConverter/WordToPdfConverter";
import PdfToWordConverter from "./components/FileConverter/PdfToWordConverter";
import QRCodeGenerator from "./components/QRCode/QRCodeGenerator";
import { useEffect, useState } from "react";
import Login from "./components/Login";
import PDFQrViewer from "./components/QRCode/PDFQrViewer";
import PdfQrCode from "./components/QRCode/PdfQrGenerator";

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    setIsLoggedIn(localStorage.getItem("isLoggedIn"))
  }, [])

  return (
    <>
      {isLoggedIn ? (
        <>
          <Header />

          <div class="container-fluid">
            <div class="row">
              <SideNavbar />

              <main class="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                <Routes>
                  <Route path="/" exact element={<Dashboard />} />
                  <Route path="/dashboard" exact element={<Dashboard />} />
                  <Route
                    path="/contact-qrcode"
                    exact
                    element={<ContactQRCode />}
                  />
                  <Route
                    path="/url-qrcode"
                    exact
                    element={<QRCodeGenerator />}
                  />
                    <Route
                    path="/pdf-viewer"
                    exact
                    element={<PDFQrViewer />}
                  />
                    <Route
                    path="/pdf-qrcode"
                    exact
                    element={<PdfQrCode />}
                  />
                  
                  <Route
                    path="/word-pdf-converter"
                    exact
                    element={<WordToPdfConverter />}
                  />
                  <Route
                    path="/pdf-word-converter"
                    exact
                    element={<PdfToWordConverter />}
                  />
                </Routes>
              </main>
            </div>
          </div>
        </>
      ) : (
        <>
          <Routes>
            <Route path="/" exact element={<Login />} />
          </Routes>
        </>
      )}
    </>
  );
};

export default App;
